import React from 'react';
import '../template-file-css/document-file-template.css';


export const AFHS_EmployeeHandbook = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='AFHS_EmployeeHandbook' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>New Hire Orientation And Employee Handbook</h3></p>

                <p className='w-750'><h4><b>Table of Contents:</b></h4>
                    <ol><li>Vision Mission Values</li>
                        <li>Equal Opportunity Employer</li>
                        <li>Rights of Management</li>
                        <li>New Employee Orientation</li>
                        <ol type='a'>
                            <li>Probationary Period </li>
                            <li>Full time Employment/Part time Employment </li>
                            <li>Exempt Employees </li>
                            <li>Personal Data Changes</li>
                            <li>Performance Evaluations</li>
                            <li>Pay Raises</li></ol>
                        <li>Contractors</li>
                        <li>Suggestions and Ideas</li>
                        <li>Non-Harassment/ Work Place Violence</li>
                        <li>Sexual Harassment</li>
                        <li>Benefits</li>
                        <li> Holidays</li>
                        <li>Vacations</li>
                        <li>Insurance/Jury Duty</li>
                        <li>Attendance and Punctuality</li>
                        <li>Electronic Devices (cell phones; laptops)</li>
                        <li>Smoking in the workplace</li>
                        <li>Good House Keeping</li>
                        <li>Work Week</li>
                        <li>Covid-19 Policy</li>
                        <li>Care of Equipment</li>
                        <li>Vehicles</li>
                        <li>Leave of Absence</li>
                        <li>Pay Roll
                            <ol type='a'>
                                <li>Pay day</li>
                                <li>Mileage reimbursement</li>
                                <li>Training reimbursements</li>
                                <li>Garnishment/child support</li>
                                <li>Leave</li>
                            </ol>
                        </li>
                        <li>Conduct and disciplinary actions
                            <ol><li>Standard of Conduct</li>
                                <li>Each Employee's Responsibility</li>
                                <li>Employee Conduct and Work Rules</li>
                                <li>Offenses(Occurrences/Write Ups)</li></ol>
                        </li>

                        <li>Drug and Alcohol-Free Workplace</li>
                        <li>Protecting Company Information
                            <ol><li>HIPPA</li>
                                <li>Confidentiality agreements</li>
                                <li>Customer and Public Relations</li>
                                <li>Conduct at job site</li>
                                <li>Dress Policy</li>
                                <li>Uniforms</li></ol>

                        </li>
                    </ol>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Mission:</span>
                    It is the mission of APEX Family Healthcare Services, Incorporated to improve the
                    standard and quality of life for citizens of our communities. We will achieve this mission
                    through the provision of needs analyses, case management, therapeutic intervention
                    and community linkage. Our desired outcomes are to reduce barriers and increase
                    access to mental health, educational and medical services. Consequently, it is our
                    commitment to inspire and promote optimal development in the life of each individual.</p>

                <p className='w-750'>
                    <span className='eleHeader'>Vision:</span>
                    APEX Family Healthcare Services, Incorporated will contribute to the creation of a
                    healthier, more harmonious community by helping Georgians acquire the counseling,
                    education, skills and resources necessary to build self-sufficient prosperous lives. We
                    commit to the attainment of our Vision through continuous quality improvement in every
                    area and level of our organization. </p>

                <p className='w-750'>
                    <span className='eleHeader'>Value Statement:</span>
                    Our focus is on the people we serve. We will strive for excellence, in documentation,
                    communication, service provision, and follow up, through the ongoing critical evaluation
                    of our desired outcomes and through our comprehensive commitment to continuous
                    quality improvement. We will - at all times - serve with empathy and compassion. <br /><br />

                    Welcome to APEX Family Healthcare Services, Inc: <br /><br />

                    Starting a new job is exciting but at times can be overwhelming. APEX Family
                    Healthcare Services, Incorporated, developed this handbook to help you get acquainted
                    as well as to answer initial questions. <br /><br />

                    As an employee/contractor of APEX, the importance of your contribution cannot be
                    overstated. Our goal is to provide the finest-quality services to our customers and to do
                    this efficiently and economically. <br /><br />

                    You are an important part of this process for your work directly influences our
                    company's reputation. <br /><br />

                    This employee handbook explains our personnel policies and the specific opportunities
                    and responsibilities that exist for you within our company. To be responsive to the
                    needs of a growing organization, changes or additions to this handbook will be made
                    when necessary. We will keep you informed when these changes are made. <br /><br />
                    We are glad you have joined us, and we hope you will find your work to be both
                    challenging and rewarding. <br /> <br />

                    This handbook is intended for use by staff members ofAPEX. This handbook is
                    designed as an informational document and does not constitute or reflect a contract.
                    The information contained herein supersedes all previous published staff handbooks
                    and is subject to change at the discretion of APEX. Policies and procedures, which may
                    be updated and approved subsequent to the publication of this document, will take
                    precedence over the contents of this handbook. <br /><br />

                    To ensure that you have the most current information, you may contact your supervisor,
                    or the Corporate Compliance Officer or access it online in the employee handbook
                    section at <a href="www.apexfamilyhealthcare.com">www.apexfamilyhealthcare.com</a></p>

                <p className='w-750'>
                    <span className='eleHeader'>EQUAL OPPORTUNITY EMPLOYER</span>
                    APEX is an Equal Opportunity Employer. This means that we will extend equal
                    opportunity to all individuals prohibits discrimination based on race, color, national
                    origin, religion, sex, sexual orientation, age disability, or veteran status, handicaps or
                    veteran status. This policy affirms APEX commitment to the principles of fair
                    employment and the elimination of all vestiges of discriminatory practices that might
                    exist. We encourage all employees/contractors to take advantage of opportunities for
                    promotion as they occur.</p>

                <p className='w-750'>
                    <span className='eleHeader'>RIGHTS OF MANAGEMENT </span>
                    APEX values the opinions of its employees/contractors made either individually or
                    through their supervisors about working conditions, ways and means of completing jobs
                    in and expeditious manner, and other matters of interest to other employees/contractors
                    and the community. However, APEX recognizes and accepts the responsibility to
                    provide the necessary atmosphere to assure quality work performance and working
                    conditions as well as provide quality care and retains the right to make decisions without
                    prior employee consultation. <br /><br />

                    APEX employees/contractors are subject to notice and are free to terminate
                    employment at any time. This handbook does not establish any guarantee of
                    employment for any length of time. We maintain exclusive discretion to exercise the
                    customary functions of management, including, but not limited to the discretion to
                    select, hire, promote, suspend, dismiss, assign, supervise, evaluate, and discipline
                    employees/contractors to determine work schedules, including hours in excess of the
                    normal work schedule, and the size and composition of the work force; renew or cancel
                    contract employees contracts, to establish, change, and abolish policies, procedures,
                    rules and regulations; to determine and modify position descriptions and position
                    classifications; to establish salary schedules and rates of pay and to assign merit and
                    other salary increases; and to assign duties to employees/contractors in accordance
                    with needs and requirements determined by APEX.  </p>

                <p className='w-750'><span className='eleHeader'>EMPLOYEE RELATIONS PHILOSOPHY</span>
                    We are committed to providing the best possible climate for maximum development for
                    all employees/contractors. Our practice is to treat each employee/contractor as an
                    individual. We seek to develop a spirit of teamwork: individuals working together to
                    attain a common goal. <br /><br />
                    In order to maintain an atmosphere where these goals can be accomplished, we will
                    provide a comfortable and progressive workplace.
                </p>
                <p className='w-750'><span className='eleHeader'>NEW HIRE ORIENTATION</span>
                    Upon joining our company, you were given this copy of our employee/contractor
                    handbook. After reading the handbook, please sign the receipt page and return it to
                    your supervisor or contract manager for the job. You will be asked to complete
                    personnel and payroll and health benefit forms (if applicable). <br /><br />
                    Your supervisor for the job is responsible for the operations of your site and she/he is a
                    good source of information about the company and your job.
                </p>
                <p className='w-750'><span className='eleHeader'>OUTSIDE EMPLOYMENT</span>
                    Our company hopes that you will not find it necessary to seek additional outside
                    employment. However, we do understand that Community Mental Health is an industry
                    built primarily of self-employed contractors, operating in Private Practices therefore, we
                    full disclosure of other employment to prevent conflict of interest should be made in
                    writing and we encourage you to enroll in our payroll system using your EIN numbers
                    where possible. If you are already contracted with Apex and are planning to accept an
                    outside position, you must notify the management in writing.</p>

                <p className='w-750'><span className='eleHeader'>SUGGESTIONS AND IDEAS</span>
                    We are always interested in your constructive ideas and suggestions for improving our
                    operations. Your suggestions should be submitted in writing to your site manager or
                    you can also contact the operations managers.
                    <br /><br />

                    After your suggestion is investigated, you will be notified whether or not it is feasible to
                    into practice. </p>

                <p className='w-750'><span className='eleHeader'>TALK TO US</span>
                    APEX encourages you to bring your questions, suggestions and complaints to our
                    attention. Careful consideration will be given to each of these in our continuing effort to
                    improve operations. <br /><br />

                    If you feel you have a problem, you should present the situation to managers so that the
                    problem can be settled by examination and discussion of the facts. <br /><br />

                    If you find that you still have questions after meeting with the site manager or that you
                    would like further clarification on the matter, you may request a meeting with the
                    Operations manager. <br /><br />

                    Your suggestions and comments on any subject are important to us so we encourage
                    you to take every opportunity to discuss them with us. Your job will not be adversely
                    affected in any way because you choose to use this procedure. </p>

                <p className='w-750'><span className='eleHeader'>NON-HARASSMENT</span>
                    We prohibit harassment of one employee/contractor by another employee/contractor or
                    supervisor for any reason including, but not limited to: veteran status, race, color,
                    religion, marital status, nation origin, physical or mental disability and/or age.
                    <br /><br />The purpose of the policy is not to regulate the personal morality of
                    employees/contractors. It is to assure that in the workplace, no employee/contractor
                    harasses another for any reason. <br /><br />

                    While it is not easy to define precisely what harassment is, it includes slurs, epithets,
                    threats, derogatory comments, unwelcome jokes and teasing. <br /><br />

                    Any employee/contractor who feels that she/he is a victim of such harassment should
                    immediately report the matter to the owners or any other member of management. Our
                    company will investigate all such report as confidentially as possible. Adverse action
                    will not be taken against an employee/contractor who report or participates in the
                    investigation of a violation of this policy. Violations of this policy are not permitted and
                    may result in disciplinary action. Up to and including discharge. </p>

                <p className='w-750'><span className='eleHeader'>SEXUAL HARASSMENT</span>
                    We prohibit sexual harassment of any employee by another employee or a supervisor.
                    The purpose of policy is not to regulate the morality of employees/contractors. It is to
                    assure that in the workplace, no employee is subject to sexual harassment is, it includes
                    unwelcome sexual advances, requests for sexual favors and/or verbal or physical
                    conduct of a sexual nature including, but not limited to, drawings, pictures, jokes,
                    teasing, uninvited touching or other sexually related comments.<br /><br />

                    Sexual harassment of an employee will not be tolerated. Violations of this policy may
                    result in disciplinary action, up to and including discharge. There will be no adverse
                    action taken against employee who report violations of the policy or participate in the
                    investigation of such violations. <br /><br />

                    Any employee who feels that she/he is a victim of sexual harassment should
                    immediately report such actions in accordance with the following procedure. All
                    complaints will be promptly and thoroughly investigated.

                    <ol>
                        <li>
                            Any employee who believes that she/he is a victim of sexual harassment should
                            report the act immediately to the president. If you prefer not to discuss the
                            matter with the president. You may contact any other member of management.</li>

                        <li>The company will investigate every reported incident immediately. Any
                            employee, supervisor to agent of the company who has been found to have
                            sexually harassed another employee may be subject to appropriate disciplinary
                            action, up to and including immediate discharge. </li>

                        <li>The company will conduct all investigation in a discreet manner. The company
                            recognizes that every investigation requires a determination based on all the
                            facts in the manner. We also recognize the serious impact a false accusation
                            can have. We trust that all employees/contractors will continue to act
                            responsibly.</li>

                        <li>The reporting employee and any employee participating in any investigation
                            under this policy has the company's assurance that no reprisals will be taken as
                            a result of a sexual harassment complaint. It is our policy to encourage
                            discussion of the matter, to help protect others from being subjected to similar
                            inappropriate behavior.</li>
                    </ol></p>

                <p className='w-750'><span className='eleHeader'>PROBATIONARY PERIOD</span>APEX employees/contractors are on a probationary period during their first 90 days of
                    employment. During this period, you will be able to determine if your new job is suitable
                    for you. Your supervisor for the job will have an opportunity to evaluate your work
                    performance. However, the completion of the probationary period does not guarantee
                    employment for any period thereafter. </p>

                <p className='w-750'><span className='eleHeader'>FULL-TIME EMPLOYEES</span>
                    Workers who work at least a 32-40-hourweeksmay be considered full time workers
                    but could still be considered independent contractors, depending on the nature of
                    your job and appropriate State Licenses.</p>

                <p className='w-750'><span className='eleHeader'>EXEMPT / NON-EXEMPT EMPLOYEES </span>
                    APEX EXEMPT employees are regarded as exempt. This means that pursuant to the
                    Fair Labor Standards Act (FLSA) and applicable state laws, exempt employees are
                    those who perform administrative, professional, supervisory or managerial
                    responsibilities. Exempt employees are not entitled to overtime pay and are not subject
                    to certain deductions to their weekly salary under the company's policies.
                    <br /><br />

                    Upon hire, your supervisor for the job will notify you of your employment classification. <br /><br />
                    APEX NON-EXEMPT employee is entitled to overtime pay through the Fair Labor
                    Standards Act (FLSA). Also, some states have expanded overtime pay guidelines.
                    Check with your state Department of Labor website for rules in your location.
                    Employers are required to pay time and a half the employee's regular rate of pay when
                    they work more than 40 hours in a given pay week. Most employees must be paid the
                    federal minimum wage ($7.25 in 2019) for regular time and at least time and a half for
                    any hours worked over the standard 40.
                </p>

                <p className='w-750'><b>Remember: Employees are paid for each hour worked from the time they Clockin for their scheduled and approved shifts until they Clock-out. Independent
                    Contractors are paid for each service provided based upon the CPT Service
                    code.
                </b></p>

                <p className='w-750'><span className='eleHeader'>INDEPENDENT CONTRACTORS</span>
                    All independent contractors must comply with the following to remain eligible to service
                    clients of Apex Family Healthcare Services regardless of program type. All Contractors
                    are responsible for the following:

                    <ul>
                        <li>
                            Pay for all pre-employment activities before contract start date (CPI, CPR, Drug
                            Screen, Background Check, TB Test, CANS/ANSA,etc…)
                        </li>

                        <li>Pay for and complete all required trainings and certifications to be eligible to
                            service clients (Essential Learning's, Trauma, etc.) </li>

                        <li>Maintain active professional liability insurance of $1,000,000 to $3,000,000 </li>

                        <li>Maintain active professional license and CEU's</li>

                        <li>Provide all work-related supplies (computers, printers, internet access, training
                            materials, resources, etc.…)
                        </li>

                        <li>Submit Monthly Availability Calendars for specific days and times slots to service
                            clients</li>

                        <li>
                            Provide a 2 hour notice to cancel/remove clients from schedule so they may be
                            placed backed into the client assignment rotation for services
                        </li>

                        <li>Submit Invoices for all documentation to be paid by universal Psychiatric CPT
                            codes </li>

                        <li>Pay all applicable state and federal taxes, social security, Medicare, etc.…. </li>

                        <li>Complete 1099 form </li>

                        <li>Maintain active and adequate internet access and telephone services </li>

                        <li>Maintain transportation, vehicle insurance, etc.…
                        </li>

                    </ul><br />
                    If you have any questions about the classifications between a contractor and employee,
                    please defer to the following: dbolar@apexfamilyhealthcare.com </p>

                <p className='w-750'><span className='eleHeader'>PERSONAL DATA CHANGES </span>
                    We need to maintain up-to-date information about you so we would be able to aid you
                    and/or your family in matters of personal emergency. Changes in name, address,
                    telephone number, marital status, number of dependents or changes in next of kin
                    and/or beneficiaries should be given to your supervisor for the job promptly. </p>

                <p className='w-750'><span className='eleHeader'>PERFORMANCE EVALUATIONS
                </span>Your performance is important to our company. Every six months, according to your
                    anniversary date, management will review your job progress within our company and
                    help you set new job performance plans/goals. <br /><br />

                    Our performance review program is designed to provide a basis for better
                    understanding, between you and management, with respect to your job performance,
                    potential and development within the company.
                    <br /><br />
                    New employees will generally be reviewed at the end of their introductory period.
                </p>

                <p className='w-750'><span className='eleHeader'>PAY RAISES </span>
                    Depending upon your performance and our company's profitability, adjustments in your
                    pay may be made when there has been an improvement in or sustainment of an
                    already good performance during the review period. </p>

                <p className='w-750'><span className='eleHeader'>BENEFITS </span>
                    APEX is a small business and offers paid holidays, flexible work schedule and
                    approved telecommuting.  </p>

                <p className='w-750'><span className='eleHeader'>HOLIDAYS: </span>
                    APEX is open 24 hours a day and 365 days in a year. We are open for business and
                    thus cannot observe any holidays by closing. Nevertheless, a pay of time and half will
                    be made on the following days for those who are on hourly wages and has completed
                    their 90 days worked probationary period. Holiday pay will be paid for full-time hourly
                    employees who are placed out of service due to the agency closing. If an employee
                    has an unplanned/unapproved absence the day before the holiday, they forfeit holiday pay.
                    <ul>
                        <li>New Year's Day</li>
                        <li>Martin Luther King Day</li>
                        <li>Thanksgiving Day</li>
                        <li>Christmas Day</li>
                        <li>Juneteenth</li>
                        <li>Labor Day</li>
                        <li>Memorial Day</li>
                        <li>Birthdays (within the month/approved day)</li>
                        <li>Independence Day</li></ul></p>

                <p className='w-750'><span className='eleHeader'>VACATION and PERSONAL/SICK TIME OFF:</span>Full-time hourly and salaried/exempt W-2 employees accrue 0.0384 hours for each
                    hour worked from their date of hire. One-half accrues as PTO and the other half
                    accrues as vacation time. No time may be taken until the 90 day probation period is
                    successfully completed.

                    <ul>
                        <li>Request for personal/sick time should be submitted on a leave request and
                            accompanied by a doctors' note if out two or more days.
                        </li>
                        <li>Vacation time requests should be submitted thirty days in advance and will be
                            approved if possible according to business needs, seniority and timeliness of
                            the request.</li>
                        <li>PTO/Vacation time will be subtracted from the employee's accrued time bank in
                            one-hour increments.</li>
                        <li>Time that is not covered by PTO/Vacation time and for which separate policies
                            exist include paid holidays, bereavement time off, required jury duty, and
                            military service leave. </li>
                        <li>Requests for more than five business days in a row can only be approved by
                            Senior Management.</li>
                        <li>Requests for time off without pay will be considered on a case-by-case basis.
                        </li></ul>
                    Each employee may carry over 20 hours of accrued PTO/Vacation time at the end of
                    the calendar year. Employees are responsible for monitoring and taking their PTO
                    over the course of a year so that they do not lose time accrued.PTO is subject to
                    supervisor approval and not every employee can take accumulated time in December.
                    If extenuating business circumstances prevented the employee from taking scheduled
                    PTO, this PTO may be carried over and taken in the first half of the next calendar year
                    with the approval of the Department Head and Human Resources. Any employee who
                    terminates the agency and have PTO remaining, will only be paid for Vacation Time
                    only, not PTO.</p>

                <p className='w-750'><h4><b>INSURANCE: TBA</b></h4></p>

                <p className='w-750'><span className='eleHeader'>JURY DUTY</span>
                    Employees summoned for jury duty are granted an unpaid leave in order to serve.
                    Arrangement must be made with your supervisor as soon as you receive your
                    summons. You are expected to return to your job immediately after you have been
                    excused (during regular working hours) from duty. Prior to Approval, a letter must be
                    shown.</p>

                <p className='w-750'><span className='eleHeader'>CELL PHONE </span>
                    Use of personal cell phones, both incoming and out-going; during company time
                    should be limited to emergencies. Failure to comply will be subject to time docked from
                    employee's pay and disciplinary action. For employees that have been issued a
                    company cell phone, this phone should be used strictly for company business and I or
                    emergencies. Employees who abuse company time will be subject to disciplinary
                    action up to and including termination.
                </p>

                <p className='w-750'><span className='eleHeader'>PERSONAL TELEPHONE CALLS </span>
                    It is important to keep our telephone lines free for incoming calls, case workers,
                    parents etc. Although the occasional use of the company's telephones for a
                    personal emergency may be necessary, routine personal calls should be kept to a
                    minimum.
                </p>

                <p className='w-750'><span className='eleHeader'>SMOKING IN THE WORKPLACE</span>
                    Our company is committed to providing a safe and healthy environment for
                    employees/contractors and visitors. Smoking is banned in the office.
                </p>

                <p className='w-750'><span className='eleHeader'>GOOD HOUSEKEEPING</span>
                    Good work habits and a neat place to work are essential for job safety and efficiency.
                    You are expected to keep your place of work organized and materials in good order,
                    documents filed in the proper place, read staff always log and bulletin board. Report
                    anything that needs repair or replacement to your site manager
                </p>

                <p className='w-750'><span className='eleHeader'>WORKWEEK</span>
                    Because the nature of our business extends outsides of the walls of our In-Office
                    Services and into the Community Based programs, your work schedule may vary
                    by days and times depending on your job and your approved work schedule.
                    Considering this, employees are to have written approval to work outside of their
                    approved work schedule. We are open 24 hours a day Sunday through Saturday
                    all year round and not closed for holidays however, our main office is open Monday
                    through Friday from 8:30am to 5:30pm.

                </p>

                <p className='w-750'><h4><b>ATTENDANCE AND PUNCTUALITY</b></h4></p>

                <p className='w-750'><span className='eleHeader'>1. Attendance policy overview</span>
                    Employees at<b>Apex Family Healthcare Services</b>are expected to be present for work, on time, every day.
                    Regular attendance and punctuality is important to keep our team and the company running smoothly.
                    Arriving late, being tardy, or absence from work causes disruptions and burdens colleagues. Apex Family
                    Healthcare Services associates a lack of attendance directly with work performance. Apex believes that
                    employees who are not at work, unavailable or unable to complete their schedule shifts will be unable
                    to satisfy the agency work duties, work-task, and work-flows to fulfill their job descriptions satisfactory.
                    <br /><br />

                    To ensure that employees are able to manage their time and attendance, employees will follow all
                    scheduled time off guidelines so that work can be distributed, reassigned or reallocated to prevent
                    disruptions to important timeline and deliverables on behalf of the agency. This can be best done by
                    submitting your schedule time off request for vacation and PTO according to policy.
                </p>

                <p className='w-750'><span className='eleHeader'>2. Scheduled Time Off </span>
                    Apex Family Healthcare Services appreciates that staffs who utilizes their time and attendance
                    effectively to assist the agency with meeting its performance measures and objectives. Considering this,
                    <br /><br />
                    <b>No Infraction Penalty will be applied for appropriate Use of Approved Scheduled Time off
                    </b> <br /><br />
                    Every staff member (full-time employee) accrues paid time off and is expected to use this within the
                    guidelines of the PTO and Vacation policy. (Vacation must be submitted 30 days before time requested
                    and all work must be current). Please see your employee manual for updates. Staff is allowed one (1)
                    additional week without pay but should not be exceeded as this would constitute infraction. The
                    following types of scheduled leave will not impose an infraction for time missed from work:
                    <ul>
                        <li>PTO (After three (3) months of employment)</li>
                        <li>Paid Holiday (After first three(3) months of employment)
                        </li>
                        <li>Birthday (After first three(3)months of employment)
                        </li>
                        <li>Vacation (After one(1)year of employment)</li></ul></p>

                <p className='w-750'><span className='eleHeader'>3. Calculation of attendance infractions for unscheduled time</span>

                    To effectively track and manage employees who fail to utilize scheduled time off as requested by the
                    agency, Apex Family healthcare services has implemented attendance infractions to deter employees
                    who abuse the attendance and punctuality policy as follows:  <br /><br />
                    To manage the attendance policy and infractions, Office Manager will review time clock daily and office
                    video if necessary.
                    <br />
                    <b>½ point: Tardy</b>
                    <ul>
                        <li>All staff can report to work at least 15 minutes before schedule shift to have breakfast and
                            socialize prior to clocking-in. After your scheduled clock in time, no socialization, breakfast, etc..
                            should be conducted but all staff should be ready for work and to receive clients, phone calls,
                            check emails, etc.. </li>
                        <li>All staff should Clock-in at 8:30am or whatever time they are scheduled to begin working and
                            report to work station</li>
                        <li>All staff is allowed a 5 minutes grace after 8:30am period for arriving and clocking-in. Again, staff
                            should report immediately to their own personal work station.
                        </li>
                        <li>Verified ½ point tardy infractions will be applied to any clock-in beginning 8:36am after the time
                            clock has been reviewed daily by Office Manager. No Exceptions.</li>
                        <li>Office manager requires staff signature on infraction document by close of business on day of
                            infraction. </li>
                        <li>PTO and Vacation time cannot be applied to tardiness.</li></ul>
                    <br />
                    <b>1 point: Tardy</b>
                    <ul>
                        <li>Any staff that arrives to work late and clock-in from 8:46am to 9am will receive a 1 point
                            infraction.</li>
                        <li>Verified 1 point tardy infractions will be applied to any clock-in at 8:46am after the time clock
                            has been reviewed daily by Office Manager. No Exceptions </li>
                        <li>Office manager requires staff signature on infraction document by close of business on day of
                            infraction.</li>
                        <li>PTO and Vacation time cannot be applied to hours missed from work due to tardiness. </li>
                    </ul>
                    <br /><br />
                    <b>Disciplinary Acton/ Shift Cancelation </b>
                    <ul><li>Any staff that reports to work after 9am should report immediately to the office manager and
                        SHOULD NOT clock in unless given approval.(No PTO or Vacation cannot be used for this reason)</li>
                        <li>Office manager will determine if staff should: </li><ul>
                            <li>Cancel scheduled shift and send home for the day with no pay</li>
                            <li>Staff should be placed on Performance Improvement Plan and an undetermined
                                number of infractions applied
                            </li>
                        </ul>
                    </ul><br />
                    <b>1 point: Call out after 7:30am (or 1 hour before scheduled shift)</b><br />
                    <ul><li>Staff will receive 1 point infraction for failure to follow callout guideline. Call outs should be
                        completed as follows: </li>
                        <ul>
                            <li>Call out to Office Manager by phone first </li>
                            <li>Followed up to Office Manager by text.</li>
                            <li>Staff should not call out to any other staff or manager without 1st contacting the office
                                manager, this includes the Executive Director and Clinical Director.
                            </li><ul>
                                <li>Staff may contact the Executive Director or Clinical Director AND the Office
                                    Manager</li></ul></ul>
                        <li>Staff inform Office Manager that call out is with either PTO or Vacation (time if available)</li>
                        <li>Staff should confirm that the Office Manager is in receipt of the call out and acknowledges that
                            call out has been received.</li>
                        <li>Staff should submit electronic Time Off request form to Office Manager and check appropriate
                            box as to whether time off is PTO or Vacation</li>
                        <li>Time off without pay is not allowed unless no time is available</li></ul>
                    <br />
                    <b>Office Managers and Directors</b>
                    <ul><li>Although MANAGERS AND DIRECTORS call-outs are made to Executive Director however; phone
                        call/text should be also sent to the Office Manager to ensure work task and phone messages can
                        be distributed accordingly. </li>
                        <li>All call-outs should indicate whether employee/manager will be using PTO or vacation time </li>
                        <li>Time off request forms from managers/directors should be sent electronically to Executive
                            Director or HR and they should coordinate with Office Manager to ensure time is tracked
                            appropriately. </li>
                        <li>Time off without pay is not allowed unless no time is available </li></ul>
                    <br />
                    <b>1 point: Late return from lunch </b>
                    <ul><li>All employees are allowed<b>5</b>minutes grace period after their 1 hour lunch period is up</li>
                        <li>1 point infraction will be applied no exceptions if  employee goes over the 5 minutes grace
                            period </li>
                        <li>Office manager requires staff signature on infraction document by close of business on day of
                            infraction. </li>
                        <li>PTO and Vacation time cannot be applied to tardiness. </li></ul>
                    <br />
                    <b>Attendance Infraction Tracking System </b>
                    <ul><li>Time clock will be reviewed daily to monitor attendance and punctuality by the office manager</li>
                        <li>Infraction report  will be pulled and report sent to managers and staff daily / weekly</li>
                        <li>Any employee who have incurred a total of <b>5 points</b>infraction points within a consecutive<b>90
                            day period</b>will result in a disciplinary action and performance improvement plan and possible
                            suspension </li></ul>
                    <br />
                    <b>Attendance Infraction Exemption based on Special Circumstances</b><br />

                    Apex understands that circumstances do arise beyond our control that may cause staff to be unable to
                    adhere to the attendance guideline. Staff can be exempt from receiving points for the following reasons
                    and should provide supporting documents. Exemptions will be review on a case by case basis
                    <ul><li>Hospital admission</li>
                        <li>Incarceration (less than 48 hours)</li>
                        <li>Doctor's excuse for employee or child (Unscheduled)</li>
                        <li>Death or Bereavement</li></ul>
                    Excessive time off attendance concerns <br />

                    Any staff who has exhausted their scheduled accrued time off for PTO and Vacation and consistently
                    continues to take days off with no pay exceeding the allowed 5 days without pay  will be considered
                    excessive and will lead to disciplinary action up to and including the following:
                    <ul><li>Performance Improvement Plan </li>
                        <li>Suspension</li>
                        <li>Termination</li></ul>
                    <b>Re-set of Infractions</b><br /><br />

                    Attendance infractions reset every consecutive<b>3 months from infraction.</b><br /><br />
                    <b>Right to file Grievance based on infraction</b><br /><br />

                    All staff members have the right to file a grievance if they are not in agreement with the infraction
                    applied.  This can be found on the bottom of the infraction form and should clearly state reason or
                    reasons the infraction was not within grounds. All grievance filed will be reviewed by the Human
                    Resource and Executive Director. <br /><br />
                    Employees are given a five-minute grace period at the start and end of each scheduled shift and for
                    breaks and for lunch. <br />

                    Employees are required to report an absence up to 24 hours in advance. Employees must report each
                    day they are absent. Failure to call-off at least an hour prior to a shift will result in a no call-no show
                    which will result in disciplinary action up to termination</p>

                <p className='w-750'><span className='eleHeader'>4. Overview of disciplinary action for attendance infractions.</span>
                    Attendance issues will result in progressive disciplinary action up to and including termination based on
                    the following point system:
                    <ul><li>3 points: Verbal warning.</li>
                        <li>4 points: Written warning.</li>
                        <li>5 points: Meeting with manager/supervisor, suspension for two days without Pay.</li>
                        <li>6 points: Employee is subject to termination.</li></ul><br /><br />

                    If an employee is absent for three or more consecutive days, evidence for excusing the absence, such as
                    a doctor's note, must be provided. <br /><br />

                    If an employee is a no call-no show for three or more consecutive days, it will be considered a job
                    abandonment or termination without notice. <br /><br />

                    Employees may request exceptions for work absences from human resources and management. These
                    must be approved on a case-by-case basis.</p>

                <p className='w-750'><span className='eleHeader'>5. Excused, unpaid absences without disciplinary action.</span>
                    Excused, unpaid absences can be granted for funerals, jury duty, childbirth, a car accident, medical
                    appointment, and unavoidable emergencies. In these cases, employees must provide documentation to
                    prove the reason for absence.</p>

                <p className='w-750'><span className='eleHeader'>6. Failure to clock-In or clock-out.</span>
                    Employees must clock-in and clock-out for each shift. If there is any problem recording a clock-in or
                    clock-out, inform employees should inform a manager immediately. Employees who consistently fail to
                    clock-in or clock-out may receive disciplinary action, up to and including termination. </p>

                <p className='w-750'><span className='eleHeader'>7. Attendance policy exceptions. </span>
                    Absence because of bereavement, jury duty, or military duty, is exempt from disciplinary action, as are
                    ADA related absences. Bereavement, jury duty and military exemptions require proper documentation
                    to be given to a manager within 48 hours of the absence. </p>

                <p className='w-750'><span className='eleHeader'>8. Lunch break.</span>
                    All in-office full time staff must take a one hour break off the clock.</p>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;</td>
                        <td className='signature w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Signature</td>
                        <td className='small w-375'>Date</td>
                    </tr>
                </table>

                <p className='w-750'><h4><b>COVID-19 Policy</b></h4>
                    Please be advised that on December 29, 2021, the Department of Public Health (DPH) issued
                    a new Administrative Order for Public Health Control Measures. This updated Administrative
                    Order contains new isolation and quarantine protocols which align with the Centers for
                    Disease Control (CDC) guidance issued December 27, 2021. <br /><br />
                    <b>Isolation</b><br /><br />

                    If you test positive for COVID-19, everyone (regardless of vaccination status) must: <br />
                    <ul><li>Isolate at home for 5 days from the date symptoms first appeared or, if asymptomatic,
                        the date of the positive test. Stay away from others in the household as much as
                        possible during isolation. </li>
                        <li>After 5 days, if you have no symptoms or your symptoms are resolving and you have
                            not had fever for more than 24 hours, without the use of fever-reducing medication, you
                            may end isolation. If symptoms are not improving or fever has not resolved, you should
                            continue isolating until the above criteria are met.</li>
                        <li>After ending isolation, you should continue to wear a mask around others for 5 days.</li>
                    </ul> <br /><br />
                    <b>Quarantine</b><br /><br />
                    If you have been exposed to someone with COVID-19 and you are: <br />
                    <ul><li>If you have been exposed to someone with COVID-19 and you are:</li>
                        <ul>
                            <li>You do not need to quarantine at home.</li>
                            <li>You should wear a mask around others for 10 days.</li>
                            <li>If possible, get tested on day 5.</li>
                            <li>If you develop symptoms, get tested and isolate at home until test results are
                                received, then proceed in accordance with the test results. </li></ul>
                        <li> Unvaccinated, or became fully vaccinated more than 6 months ago (Moderna or Pfizer
                            vaccine) or more than 2 months ago (J&J vaccine) and have not received a booster: </li>
                        <ul>
                            <li>You must quarantine at home for 5 days. After that, continue to wear a mask
                                around others for 5 additional days. </li>
                            <li>If possible, get tested on day 5.</li>
                            <li>If you develop symptoms, get tested and isolate at home until test results are
                                received, then proceed in accordance with the test results.</li>
                        </ul></ul></p>
                <p className='w-750'><span className='eleHeader'>CARE OF EQUIPMENT</span><br />
                    You are expected to use proper care when using the company's property and
                    equipment. No property may be removed from the premises without the proper
                    authorization of management. If you lose, break or damage any property, report it to
                    your supervisor for the job at once.</p>
                <p className='w-750'><span className='eleHeader'>COMPANY VEHICLES</span>
                    APEX does not currently have company vehicles however operators of company
                    vehicles are responsible for the safe operation and cleanliness of the vehicle.
                    Accidents involving a company vehicle must be reported to the management
                    immediately. <br /><br />

                    Employees/contractors are responsible for any moving and parking violations and
                    fines which may result when operating a company vehicle. Company vehicles may
                    only be used for job-related travel. The use of seatbelts is mandatory for operators
                    and passengers of company vehicles. No consumption of tobacco or alcohol
                    products is allowed in a company vehicle. </p>

                <p className='w-750'><span className='eleHeader'>WORKPLACE VIOLENCE</span>
                    Violence by an employee or anyone else against an employee, supervisor or member
                    of management will not be tolerated. The purpose of this policy is to minimize the
                    potential risk of personal injuries to employees/contractors at work and to reduce the
                    possibility of damage of company property in the event someone, for whatever reason,
                    may be unhappy with a company decision or action by and employee or member of
                    management. If you receive or overhear any threatening communications from an
                    employee or outside third party, report it to the management at once. Do not engage in
                    either physical or verbal confrontation with a potentially violent individual. If you
                    encounter an individual who is in any way threatening immediate
                    harm to an employee, management or visitor to our premises, contact and emergency
                    agency (911) immediately. <br /><br />

                    All repo APEX of work-related threats will be kept confidential to the extent possible
                    investigated and documented. Employees/contractors are encouraged to report and
                    participate in an investigation of any suspected or actual cases of workplace violence.
                    Your failure to report or fully cooperate in the company's investigation could result in
                    discipline. Violations of this policy will not be permitted and my result in disciplinary
                    action up to and including discharge. </p>

                <p className='w-750'><span className='eleHeader'>LEAVE OF ABSENCE</span>
                    Under special circumstances, an employee with six months of employment may be
                    granted a leave of absence without pay. The granting of this type of leave is normally
                    for compelling reasons and is dependent upon the written approval of the
                    management. We will make reasonable efforts to return you to the same or similar job
                    as held prior to the leave of absence, subject to our staff and business requirements.</p>

                <p className='w-750'><span className='eleHeader'>RECORDING YOUR TIME</span>
                    All employees of APEX from Management to DCS (Direct Care Staff) are to sign- in
                    and out when they show up for work utilizing our EMR or HER system. It is also
                    recommended that each employee maintain a personal log of his / her own time.
                    All time must be kept in the office.  ALL contractors must turn in their invoice five days
                    after each pay period, failure to do so will cause payroll no to be processed. If an
                    employee does not clock in, it would be assumed that they came late and one hour will
                    be deducted from the total time. Furthermore, if the employee does not clock out, it
                    would be assumed they left early, and an hour will be deducted from their total. It is
                    imperative that each employee work according to their submitted schedules to prevent
                    problems with hours. <br /><br />

                    If it is observed that based on the time sheet or our EMR or EHR system, an employee
                    is consistently late to work, that employee will be warned and disciplined. <br /><br />
                    Contractors are expected to fulfill schedules based on availability of consumers and
                    their families. </p>

                <p className='w-750'><span className='eleHeader'>CLOCKING OUT</span>
                    Everyone must clock out or sign out at the end of their shifts; all paperwork must be
                    done during shifts. APEX will not pay for any extra time after the scheduled work
                    period. If it is as a result of a person coming late to work, write the name of the person
                    and the time they were to show, and the person will be disciplined. </p>

                <p className='w-750'><span className='eleHeader'>PAYDAY</span>
                    You will be paid every two weeks,if
                    the payday falls on a weekend or holiday, you will
                    be paid on the working day prior to the weekend or holiday. <br /><br />

                    Nevertheless, during the Christmas Holidays, APEX, may decide to pay earlier, but
                    employees/contractors are advised not to expect an early pay incase the company
                    does not make it. <br /><br />

                    Please review your paycheck for errors. If you find a mistake, report it to the operations
                    immediately. If it is an error by the company, it will be adjusted immediately and sent to
                    processing however  if it is by the employees/contractors /contractor's omission,
                    it
                    be adjusted on the next pay period. </p>

                <p className='w-750'><span className='eleHeader'>MILEAGE REIMBURSEMENT</span>
                    The company may from time to time need employees to use their own vehicles or
                    gas to travel. Mileage is not reimbursed by Medicaid. Contractors are expected to
                    determine means of transportation prior to accepting any positions with RTS.
                    Contractors must also consider full coverage with a minimum amount of
                    100,000/300,000. </p>

                <p className='w-750'><span className='eleHeader'>GARNISHMENT CHILD SUPPORT  </span>
                    When an employee's/contractor wages are garnished by a court order, our company is
                    legally bound to withhold the amount indicated in the garnishment order from the
                    employee's/contractor paycheck. Our company will, however, honor Federal and State
                    guidelines which protect a certain amount of an employee's income from being subject
                    to garnishment. </p>

                <p className='w-750'><span className='eleHeader'>IF YOU MUST LEAVE US</span>
                    Should you decide to leave your employment/contract with us, we ask that you
                    provide the management with at least two weeks' advance notice. Your
                    thoughtfulness will be appreciated and will be noted favorably should you ever wish
                    to reapply for employment with the company. Failing to do so will lead to the
                    consequences stated in your contract or terms of agreement. You should notify the
                    company if your address changes during the calendar year in which termination
                    occurs so that your tax information will be sent to the proper address. <br /><br />

                    To return to work when family leave ends, the employee will be reinstated to the same
                    position, if it is available, or to an equivalent position for which the employee is
                    qualified. <br /><br />

                    If an employee fails to return to work on the agreed upon return date, the employee will
                    be considered to have resigned.</p>

                <p className='w-750'><span className='eleHeader'>STANDARDS OF CONDUCT</span>
                    Each employee/contractor always has an obligation to observe and follow the
                    company's policies and to maintain proper standards of conduct. If an individual's
                    behavior interferes with the orderly and efficient operation of a department, corrective
                    disciplinary measures will be taken.   <br /><br />

                    Disciplinary action may include a verbal warning written warning, suspension without
                    pay and discharge. The appropriate disciplinary action imposed will be determined by
                    the company. The company does not guarantee that one form of action will
                    necessarily precede another.<br /><br />

                    The following may result in disciplinary action, up to and including discharge:
                    <ul>
                        <li>Violation of the company's policies or safety rules.</li>
                        <li>Insubordination</li>
                        <li>Poor attendance</li>
                        <li>Unauthorized possession, use, or sale of alcohol or controlled substances on work
                            premises or during working hours.</li>
                        <li> Unauthorized possession, use or sale of weapons, firearms or explosives on work
                            premises.</li>
                        <li>Poor performance</li>
                        <li>Theft or dishonesty</li>
                        <li>Physical harassment, sexual harassment or disrespect toward fellow
                            employees/contractors, visitors or other members of the public.</li></ul>

                    These examples are not all inclusive. We emphasize that discharge decisions will be
                    based on an assessment of all relevant factors. Nothing in this policy is designed to
                    modify our employment-at-will policy </p>

                <p className='w-750'><center><h4><b>Code of Conduct</b></h4></center>
                    It is the policy of APEX Family Healthcare Services, Incorporated that all full and part
                    time employees, contractors, students, volunteers (collectively referred to as “staff”),
                    and members of the governing authority are expected to perform their designated
                    functions in a manner that reflects the highest standards of ethical behavior.  The ethical
                    standards contained in this policy shape the culture and norms of APEX's administrative
                    operations and clinical practices, and both staff and members of the governing authority
                    will be held fully accountable to these standards. In addition to the specific guidelines
                    contained in the policy, professionals are expected to follow the ethical standards
                    required by their specific licensing and certification boards.  The Code of Conduct Policy
                    is to ensure that all employees/contractors ' actions reflect a competent, respectful, and
                    professional approach when serving our consumers, their families and/or
                    representatives, working with other providers of services, and interacting within the
                    communities we serve.  It is expected that staff and members of the governing authority
                    will perform their duties in compliance with all federal, state, and local regulations in
                    accordance with guidelines set forth in this policy. Violation of guidelines within the
                    Code of Conduct Policy can lead to disciplinary actions, including termination of
                    employment.

                    <b>PROCEDURES: </b><br />
                    <span className='eleHeader'>A. Professional Conduct:</span>
                    <ol>
                        <li>Staff will respect the rights of our consumers by demonstrating full integration
                            of the guidelines contained in the Rights and Responsibility Policy. This includes the right of the consumer to make autonomous decisions and fully
                            participate in every aspect of the service delivery process.</li> <br />
                        <li>APEX employees/contractors will provide services in a manner that fully
                            respects the confidentiality of consumers, by demonst</li><br />
                        <li>APEX employees/contractors will be fair and honest in their work. They will
                            not exploit or mislead, and will be faithful to their contractual obligations and
                            their word. </li><br />
                        <li>To prevent and avoid unethical conduct, APEX employees/contractors will
                            consult with, refer to, and cooperate with other professionals. APEX
                            employees/contractors will clarify their professional roles and obligations and
                            be accountable for upholding professional standards of practice.
                        </li>
                    </ol></p>
                <p className='w-750'><span className='eleHeader'>B. Personal/Professional Conduct:
                </span>
                    <ol>
                        <li>All prior personal relationships between staff and persons entering the
                            organization's programs shall be disclosed by the staff member and subject to
                            review by the appropriate supervisor.
                        </li><br />
                        <li> Staff will limit relationships with persons served to their defined professional
                            roles.</li><br />
                        <li>Staff will not establish ongoing personal or business relationships with
                            consumers receiving services. </li><br />
                        <li>Staff will conduct themselves in a professional, ethical, and moral manner. </li><br />
                        <li>Sexual relationships between staff and people served are never appropriate.
                            Sexual relationships include, but are not limited to the following: engaging in
                            any type of sexual activity, flirting, advances and/or propositions of a sexual
                            nature, comments of a sexual nature about an individual's body, clothing, or
                            lewd sexually suggestive comments.</li><br />
                        <li>Staff will not accept gifts of value from a consumer, family member, or
                            stakeholder, and cannot accept personal favors or benefits that may
                            reasonably be construed as influencing their conduct.</li></ol>
                </p>

                <p className='w-750'><span className='eleHeader'>C. Business Practices:</span>
                    <ol><li>APEX will utilize the Corporate Compliance Officer to ensure that it conducts
                        business in an ethical manner and ensure that any business practices that are questionable are thoroughly investigated the ethical investigation
                        procedures that follow in this policy. </li>
                        <li>All financial, purchasing, personnel, facility development and information
                            technology practices shall comply with local, state, and federal law and
                            guidelines. </li>
                        <li>All employees/contractors shall adhere to APEX's Human Resource Policies
                            and Procedures. </li></ol></p>

                <p className='w-750'><span className='eleHeader'>D. Marketing Practices:</span>
                    <ol><li>APEX will conduct marketing practices in an honest and factual manner.
                        Marketing materials and practices will in no way mislead the public or
                        misrepresent APEX's abilities to provide services. APEX will not claim any
                        service outcomes unless represented by valid and reliable outcome data
                        and/or research studies.</li><br />
                        <li>APEX will utilize clear and consistent methods of communicating information
                            to consumers, family members, third-party entities, referral sources, funding
                            sources, and community members, and will exhibit sensitivity to the
                            educational and reading levels of all persons when distributing information.</li><br />
                        <li>APEX will not utilize monetary rewards or gifts to any potential consumer of
                            services in an attempt to entice them to enter programs.</li></ol></p>

                <p className='w-750'><span className='eleHeader'>E. Clinical Practices:</span>
                    <ol><li>Staff will adhere to all professional codes of conduct and ethical standards for
                        his/her specified professional discipline. </li><br />
                        <li>As part of new employee orientation, staff will read the organization's Code of
                            Conduct and demonstrate knowledge of the guidelines.</li></ol></p>

                <p className='w-750'><span className='eleHeader'>F. Potential Conflicts of Interest:</span>
                    <ol><li>No consumer will be hired or placed in an employee/employer relationship
                        with APEX while an active participant in programming.
                    </li>
                        <li>Any programming that involves a work task, and remuneration for the task,
                            will be therapeutic in nature and will be documented as such by programming
                            guidelines based on theoretical constructs. </li><br />
                        <li>APEX employees will not engage in outside professional mental health
                            services that are incompatible or in conflict with job duties within the
                            organization. </li><br />
                        <li>Private practice must be done on the staff's own time and outside the
                            organization, as long as such activities are not adverse to the interests and
                            goals of APEX and have met the organization's guidelines on conducting a
                            private practice. </li><br />
                        <li>Staff will not recruit clients for their private practice within their professional
                            roles as APEX staff members.</li><br />
                        <li>If an employee leaves APEX and enters private practice, the consumer may
                            choose to continue their therapy with the former employee. However, the
                            therapy must be offered at the same cost with equal accessibility to therapy. </li><br />
                        <li>No staff shall engage in any other employment or activity on the
                            organization's premises or to an extent that affects, or is likely to affect, his or
                            her usefulness as an employee of the organization.
                        </li></ol></p>

                <p className='w-750'><span className='eleHeader'>G. Quality of Care:</span>
                    <ol><li>APEX will provide quality behavioral health care in a manner that is
                        appropriate, determined to be necessary, efficient, and effective.</li><br />
                        <li>Health care professionals will follow current ethical standards regarding
                            communication with consumers and their representatives regarding services
                            provided.</li><br />
                        <li>APEX will inform consumers about alternatives and risks associated with the
                            care they are seeking and obtain informed consent prior to any clinical
                            interventions.</li><br />
                        <li> APEX recognizes the right of consumers to make choices about their own
                            care, including the right to do without recommended care or to refuse care.</li></ol></p>

                <p className='w-750'><span className='eleHeader'>H. Necessity of Care:</span>
                    <ol><li>APEX shall submit claims for payment to governmental, private, or individual
                        payers for those services or items that are clinically necessary and
                        appropriate</li><br />
                        <li>When providing services, APEX employees shall only provide those services
                            that are consistent with generally accepted standards for treatment and are
                            determined by the professional to be clinically necessary and appropriate. </li>
                        <li>Service providers may determine that services are clinically necessary or
                            appropriate; however, the consumers funding source may not cover or
                            approve those services. In such a case, the consumer may request the
                            submission of a claim for the services to protect his/her rights with respect to
                            those services or to determine the extent of coverage provided by the payer.</li><br />
                        <li>Coding and documentation will be consistent with the standards and practices
                            defined by the organization in its policy, procedures, and guidelines.</li></ol></p>

                <p className='w-750'><span className='eleHeader'>I. Coding, Billing, and Accounting: </span>
                    <ol><li>APEX employees involved in coding, billing, documentation and accounting
                        for consumer care services for the purpose of governmental, private or
                        individual payers will comply with all applicable state and federal regulations
                        and organizational policies and procedures.</li><br />
                        <li>APEX will only bill for services rendered and shall seek the amount to which it
                            is entitled.</li><br />
                        <li> Supporting clinical documentation will be prepared for all services rendered. If
                            the appropriate and required documentation has not been provided, then the
                            service has not been rendered. Clinical documentation is paid per service
                            code for face to face services and does not include documentation time. The
                            state does not allow recoupment of any fees for documentation.</li><br />
                        <li>All services must be accurately and completely coded and submitted to the
                            appropriate payer in accordance with applicable regulations, laws, contracts,
                            and organizational policies and procedures. Federal and state regulations
                            take precedence, and organizational policies and procedures must reflect
                            those regulations. </li><br />
                        <li>Consumers shall be consistently and uniformly charged.</li><br />
                        <li>Government payers shall not be charged in excess of the provider's usual
                            charges.</li><br />
                        <li>Billing and collections will be recorded in the appropriated accounts</li><br />
                        <li>An accurate and timely billing structure and medical records system will
                            ensure that APEX effectively implements and complies with required policies
                            and procedures.</li></ol></p>

                <p className='w-750'><span className='eleHeader'>J. Cost Reports:</span>
                    <ol><li>APEX will ensure that all preparation and cost reports submitted to
                        governmental and private organizations are properly prepared and
                        documented according to all applicable federal and state laws.
                    </li>
                        <li>All cost reports will be submitted and prepared with all costs properly
                            classified, allocated to the correct cost centers, and supported by verifiable
                            and auditable cost data.</li><br />
                        <li>All cost report preparation or submission errors and mistakes will be corrected
                            in a timely manner and, if necessary, clarify procedures and educate
                            employees to prevent or minimize recurrence of those errors.</li></ol></p>

                <p className='w-750'><span className='eleHeader'>K. Personal and Confidential Information:
                </span>
                    <ol><li>APEX will protect personal and confidential information concerning the
                        organization's system, employees/contractors, and consumers.</li><br />
                        <li>APEX personnel shall not disclose confidential consumer information unless
                            at the consumer's request and/or when authorized by law. Appropriate use of
                            consumer information for research purposes must be obtained with the full
                            informed consent of participants in the research</li><br />
                        <li>Confidential information will only be discussed with or disclosed to persons
                            and entities outside the organization through the request of the consumer.
                            Persons outside the organization include the family, business, or social
                            acquaintances of the consumer.</li><br />
                        <li>Consumers can request and are entitled to receive copies or summaries of
                            their records excluding progress notes except for minors and consumers
                            being treated for alcohol and drug abuse, who may be provided with copies of
                            their record if it is court ordered and signed by judge.</li><br />
                        <li> APEX personnel will be familiar with all organizational policy and procedures
                            regarding confidentiality.</li></ol></p>

                <p className='w-750'><span className='eleHeader'>L. Creation and Retention or Consumer and Institutional Records:</span>
                    <ol><li>Records are the property of the organization. Personnel responsible for the
                        preparation and retention of records shall ensure that those records are
                        accurately prepared and maintained in a manner and location as prescribed
                        by law and organizational policy. </li><br />
                        <li>Employees/Contractors will not knowingly create records that contain any
                            false, fraudulent, fictitious, deceptive, or misleading information.</li><br />
                        <li> Employees/Contractors will not delete any entry from a record. Records can
                            be amended and material added to ensure the accuracy of a record in
                            accordance with policy and procedures. If a record is amended, it must
                            indicate that the notation is an addition or correction and record the actual
                            date that the additional entry was made.
                        </li>
                        <li> Employees/Contractors will not sign someone else's signature or initials on a
                            record.</li><br />
                        <li>Records shall be maintained according to specific organizational policy and
                            procedure. </li><br />
                        <li> Employees/Contractors shall not destroy or remove any record from the
                            organization's premises.</li><br />
                        <li>The organization will maintain record retention and record destruction policies
                            and procedures consistent with federal and state requirements regarding the
                            appropriate time periods for maintenance and location of records. Premature
                            destruction of records could be misinterpreted as an effort to destroy
                            evidence or hide information.</li></ol></p>

                <p className='w-750'><span className='eleHeader'>M. Government Investigation:</span>
                    <ol><li> APEX employees shall cooperate fully with appropriately authorized
                        governmental investigations and audits.</li><br />
                        <li> APEX will respond in an orderly fashion to the government's request for
                            information through employee interviews and documentation review. </li><br />
                        <li> The organization will respond to the government's request for information in a
                            manner that enables the organization to protect both the organization and
                            consumer's interests, while cooperating fully with the investigation.</li><br />
                        <li>When a representative from a federal or state agency contacts a APEX
                            employee at home or at their office for information regarding the organization
                            or any other entity with which the organization does business, the individual
                            will contact the Executive Director immediately. If the Executive Director is not
                            available, the individual will contact the Administrator.</li><br />
                        <li> APEX employees will ask to see the government representative's
                            identification and business card, if the government representative presents in
                            person. Otherwise, the employee should ask for the person's name, office,
                            address, phone number, and identification number and then contact the
                            person's office to confirm his/her identity.</li></ol></p>

                <p className='w-750'><span className='eleHeader'>N. Prevention of Improper Referrals or Payments:
                </span>
                    <ol><li>APEX Employees/Contractors will not accept, for themselves or for the
                        organization, anything of value in exchange for referrals of business or the
                        referral of consumers.
                    </li>
                        <li>Employees/Contractors must not offer or receive any item or service of value
                            as an inducement for the referral of business or consumers. </li><br />
                        <li>Federal law prohibits anyone from offering anything of value to a Medicare or
                            Medicaid consumer that is likely to influence that person's decision to select
                            or receive care from a behavioral health care provider.</li><br />
                        <li>The organization shall establish procedures for the review of all pricing and
                            discounting decisions to ensure that appropriate factors have been
                            considered and that the bases for such arrangements are documented. </li><br />
                        <li>Development or initiation of joint ventures, partnerships, and corporations
                            within the organization must be reviewed and approved by the organization's
                            management to ensure compliance with organizational policy and federal
                            regulations.</li></ol></p>

                <p className='w-750'><span className='eleHeader'>O. Antitrust Regulations:
                </span>
                    <ol><li>APEX will comply with all applicable federal and state antitrust laws. </li><br />
                        <li>Employees/Contractors should not agree or attempt to agree with a
                            competitor to artificially set prices or salaries, divide markets, restrict output,
                            or block new competitors from the market, share pricing information that is not
                            normally available to the public, deny staff privileges to qualified practitioners,
                            or agree to or participate with competitors in a boycott of government
                            programs, insurance companies, or particular drugs or products.</li></ol></p>

                <p className='w-750'><span className='eleHeader'>P. Avoiding Conflicts of Interest:
                </span>
                    <ol><li>All APEX Employees/Contractors shall conduct clinical and personal business
                        in a manner that avoids potential or actual conflicts of interests.</li><br />
                        <li>Employees/Contractors shall not use their official positions to influence an
                            organizational decision in which they know, or have reason to know, that they
                            have a financial interest.</li><br />
                        <li>Employees/Contractors must be knowledgeable about activities that may be
                            an actual or potential conflict of interest. Examples of such activities may
                            include, but are not limited to the following:</li><ol type='a'>
                            <li>Giving or receiving gifts, gratuities, loans, or other special treatment of
                                value from third parties doing business with or wishing to do business
                                with the organization. Third parties may include, but are not limited to,
                                consumers, vendors, suppliers, competitors, payers, carriers, and
                                fiscal intermediaries. </li><br />
                            <li>Using APEX facilities or resources for other that organization
                                sanctioned activities.</li><br />
                            <li>Using RTS's name to promote or sell products or personal services</li><br />
                            <li>Contracting for goods or services with family members of the
                                organization directly involved in the purchasing decision.</li></ol></ol></p>

                <p className='w-750'><span className='eleHeader'>Q. External Relations:
                </span>
                    <ol><li>APEX Employees/Contractors shall adhere to fair business practices and
                        accurately and honestly represent themselves and the organization's
                        services.</li><br />
                        <li>APEX Employees/Contractors will be honest and truthful in all marketing and
                            advertising practices pertaining to the business practices of the organizations
                            service delivery system</li><br />
                        <li>Vendors who contract to provide goods and services to the organization will
                            be selected based on quality, cost-effectiveness and appropriateness for the
                            identified task or need, in accordance with organization policy.
                        </li></ol></p>

                <p className='w-750'><span className='eleHeader'>R. Treatment of Employees/Contractors:</span>
                    <ol><li>APEX prohibits discrimination in any work related decision on the basis of
                        race, color, national origin, religion, sex, physical or mental disability,
                        ancestry, marital status, age, sexual orientation, citizenship, or status as a
                        covered veteran. The organization is committed to providing equal
                        employment opportunity in a work environment where each employee is
                        treated with fairness, dignity, and respect.
                    </li><br />
                        <li>APEX will make reasonable accommodations to the known physical and
                            mental limitations of otherwise qualified individuals with disabilities.
                        </li><br />
                        <li>APEX does not tolerate harassment or discrimination by anyone based on the
                            diverse characteristics or cultural backgrounds of those who work for the
                            organization pursuant to the organization's affirmative action policy.</li><br />
                        <li>Any form of sexual harassment is prohibited.
                        </li><br />
                        <li>Any form of workplace violence is prohibited.</li></ol></p>

                <p className='w-750'><span className='eleHeader'>S. Code of Conduct Procedures: </span>
                    <ol><li>All Employees/Contractors, students, volunteers and governing authority
                        members, as part of the organization's initial orientation, will review the Code of Conduct, including the procedures for investigating and acting on conduct
                        violations.</li><br />
                        <li>All staff will receive a copy of the Code of Conduct, sign a form
                            acknowledging their review and full understanding of the code, and return the
                            form to be filed in the employee's personnel file.</li><br />
                        <li>To assure an awareness of ethical practices, reviews of the Code of Conduct
                            and continued training will be conducted on an annual basis.</li></ol></p>

                <p className='w-750'><span className='eleHeader'>T. Procedures for Investigating and Acting on Violations of the Code of Conduct:
                </span>
                    <ol><li>When any consumer, family member, authorized representative, advocate or
                        other person believes that an ethical violation has occurred within the
                        operations of the organization, they may report such suspicion directly to any
                        employee, or management staff.</li><br />
                        <li>When Employees/Contractors believe a violation of the Code of Conduct has
                            occurred they are obligated to report the violation in one of the following
                            ways:</li><br />
                        <ol type='a'>
                            <li> Immediate notification of the incident or violation through the
                                organization's corporate compliance program and reporting
                                mechanisms. </li><br />
                            <li>Immediate reporting to their supervisor or to corporate compliance
                                officer if the suspected violation involves their supervisor.</li></ol>
                        <li> Supervisors who have been informed of a suspected violation are required to
                            immediately inform the corporate compliance officer of the suspected
                            violation</li><br />
                        <li>If the violation involves a direct and immediate threat to the safety of a
                            patient, staff member, or clinic visitor, Employees/Contractors are obligated to
                            report the alleged violation immediately to their supervisor.</li><br />
                        <li>Staff is required to report any suspected violation of the Code of Conduct;
                            however, they are not required to investigate or know for certain that a
                            violation has occurred.</li><br />
                        <li>Once the questionable behavior has been brought to the attention of the
                            supervisor or reported through the corporate compliance procedures, staff
                            reporting the situation will no longer have a responsibility for being involved
                            with the investigation other than providing additional information through a
                            requested interview by the investigator.</li><br />
                        <li>Staff must report each suspected violation of the Code of Conduct separately,
                            should a violation that has been reported occur again.</li><br />
                        <li>When any suspected violation of the Code of Conduct is reported to a
                            supervisor, program sponsor or the corporate compliance officer, the
                            corporate compliance officer will begin an investigation of the matter
                            immediately. While investigating the complaint, the following issues should be
                            considered and action taken depending on the situation:
                        </li><ol type='a'>
                            <li>Is any client in any harm or potential harm because of this behavior?</li><br />
                            <li>Does the complaint require immediate action to remove the employee
                                from contact with a client? </li><br />
                            <li>Does the complaint put APEX or its employee in a potentially liable
                                situation that needs legal consultation?
                            </li></ol>
                        <li>Code of Conduct investigations will follow the guidelines outlined in the RTS'
                            Corporate Compliance Policy and Procedure.
                        </li></ol></p>

                <p className='w-750'><span className='eleHeader'>U. General Ethical Guidelines and Considerations:</span>
                    <ol><li>The Code of Conduct is shared with persons served during client orientation
                        and is posted throughout public areas in all owned, leased, or rented facilities.</li><br />
                        <li>APEX believes in the importance of ethical practices within the organization.
                            Any employee who reports waste, fraud, abuse or any other questionable
                            practices will not be subject to reprisal by management of the organization.
                            To assure that reprisal is not used, the organization's governance authority
                            will serve as advocates for any employee who reports questionable practices.
                            The Corporate Compliance Officer will provide assurance and oversight that
                            there are no adverse actions toward the employee. </li><br />
                        <li>The following violations of the Code of Conduct will result in termination of
                            employment: Theft of funds, and/or physical, emotional, or sexual abuse of a
                            client or employee. </li></ol></p>

                <p className='w-750'><span className='eleHeader'>EMPLOYEE'S RESPONSIBILITY</span>
                    Each employee, supervisor and manager must practice proper supervision and
                    awareness when dealing with clients by anticipating unsafe situations and reporting
                    unsafe conditions immediately. <br /><br />
                    Please observe the following precautions:
                    <ul><li>Notify your supervisor for the job of any emergency.
                    </li><br />
                        <li>The unauthorized use of alcoholic beverages or illegal drugs during working hours will
                            not be tolerated. The use of prescription drugs that may impair you vision, judgment or
                            motor skill in anyway should be avoided during working hours. The possession of
                            alcoholic beverages or illegal drug/substances on the company's property is forbidden</li><br />
                        <li>Understand your job fully and follow instruction. If you are not sure of the safe
                            procedure, don't guess, ask your supervisor for the job.
                        </li>Know the locations, contents and use of first aid and fire-fighting equipment </ul></p>

                <p className='w-750'><span className='eleHeader'>EMPLOYEE CONDUCT AND WORK RULES </span>
                    Employees/Contractors of APEX should conduct themselves at all times in a manner
                    that will reflect professionally upon one's self. The following rules and regulations are
                    provided so that you will know what is expected of you. A violation of these rules will
                    result in disciplinary action or termination of contractor's contracts, as indicated.
                    Discipline ranges from a verbal reprimand to discharge, depending upon whether it is a
                    first violation or a recurrence, and the seriousness of the violation. A combination of
                    violations will be dealt with according to the circumstances of each individual case. <br /><br />

                    No list of work rules could cover all possible acts of improper behavior; therefore,
                    each employee must exercise good judgment for proper and mature behavior. Any
                    employee, who engages in any job-related misconduct, although the conduct is not
                    specifically named in the work rules, may be disciplined or discharged. <br /><br />

                    The rules set forth in this section of the Handbook apply for specific offenses. This rule
                    is not intended to impose a rigid limitation upon management when dealing with
                    disciplinary matters nor is it the intent of the rules to discipline any employee when a
                    violation is minor or is an isolated incident in an otherwise good work record. A more
                    severe penalty may be imposed than that prescribed below if it is deemed necessary
                    due to the seriousness and nature of the offense, the record of the employee or other
                    applicable factors. Likewise, supervisors with authority to review and impose penalties
                    may impose less than the maximum penalties for violations of the rules set forth in the
                    Handbook when extenuating circumstances are found to exist. <br /><br />

                    You should read this document carefully. If you have any questions, you should not
                    hesitate to ask for clarification from your supervisor or the administrative staff.

                </p>

                <p className='w-750'><h4><b>OFFENSES</b></h4></p>

                <p className='w-750'><span className='eleHeader'>Class I Offenses </span>
                    The penalty for Class I Offenses, or a combination of those offenses, shall be a
                    verbal reprimand for the first (1st) offense, a written reprimand for the second (2nd)
                    violation of the rules and termination for a third (3rd) offense.
                    <ol type='A'>
                        <li>Absence from duty, without prior permission from the supervisor except for cause
                            beyond the control of the employee which prevents obtaining prior approval. When
                            advance notice cannot be given, Employees/Contractors are expected to notify their
                            supervisor or department head, of the reasons for their absence and the expected time
                            of their return written proof.</li> <br />
                        <li>Failure to commence work at the beginning of the duty period and leaving work prior
                            to the end of the day. All Employees/Contractors are expected t work, from the
                            beginning to the end of the day and neither arrive late not leave early.
                        </li><br />
                        <li>Violation of Attendance and Punctuality, including failure to provide advance
                            notice of absence from work or late arrival. </li><br />
                        <li>Making or receiving excessive personal telephone calls.
                        </li><br />
                        <li>Use of derogatory or profane language toward fellow employees/Contractors,
                            residents and/or the general public.</li><br />
                        <li>Failure to submit time sheet in by designated time. </li><br />
                        <li>Unsatisfactory work and/or failure to maintain required standards of performance
                            including failure to complete regularly assigned duties like documentation and
                            supervision.</li><br />
                        <li>Failure to follow applicable agency dress code at all times. In addition to being
                            subject to disciplinary action, employees/contractors who arrive at work or are found
                            working while inappropriately dressed will not be permitted to begin or continue work.
                            Whichever is applicable, until such time as they are properly attired, nor will they be
                            compensated for the time lost.
                        </li><br />
                        <li>Solicitation during working time.</li><br />
                        <li>Deliberate neglect or carelessness in observance of APEX rules, official safety
                            and supervision rules, or disregard of common safety practices.</li><br />
                        <li>Wasting time, loitering, loafing, and horseplay, disregarding job duties by neglect of
                            work or reading for pleasure during working hours.</li></ol></p>

                <p className='w-750'><span className='eleHeader'>CLASS II OFFENSES </span>
                    <ol type='A'>
                        <li>The use of abusive, coercive or threatening language, including the threat of
                            physical violence, toward subordinates members of the supervisory force, fellow
                            employees/contractors or the general public. </li><br />
                        <li> Sleeping during scheduled working hours. </li><br />
                        <li>Failure to immediately report, accidents involving company equipment
                        </li><br />
                        <li>Failure to immediately report personal injuries, or injuries of coworkers, to the
                            company during the shift in which injury (s) occur. </li><br />
                    </ol></p>

                <p className='w-750'><span className='eleHeader'>CLASS III OFFENSES</span>
                    The penalty for a Class III Offense shall be five (5) day suspension without pay for
                    the first (ISP,) offense, and termination for the second (2 violation of the rules.
                    <ol type='A'>
                        <li> Gambling on company lime or jobsite.</li><br />
                        <li>Insubordination by the refusal to perform work assigned, refusal to comply with
                            written or verbal instructions of the supervisor which the employee may reasonably
                            be expected to perform or receiving directions or instructions in an insolent or
                            defiant manner. </li><br />
                        <li>Repeated violation of work or safety rules.</li><br />
                        <li>Failure without good cause to report, within 24 hours, accidents involving motor
                            vehicles in which damage is caused to public, private or company property,
                            including company cars, trucks, buildings, equipment, etc.</li><br />
                        <li>Not showing up for work without calling or contacting the proper authority. </li></ol></p>

                <p className='w-750'><span className='eleHeader'>CLASS IV OFFENSES</span>
                    The penalty for a Class IV Offense is <b>DISCHARGE</b>.
                    <ol type='A'>
                        <li>Possession of alcoholic beverages, narcotics, firearms (or other lethal weapon),
                            concealed or otherwise, on premises, even if employee possesses a concealed
                            weapons permit.</li><br />
                        <li>Any intentional misrepresentation or falsification of time reports. Falsifying testimony
                            when accidents are being investigated or falsifying or assisting in falsifying personnel or
                            other records, including production or work performance reports; or giving false
                            information or withholding pertinent information called for in making application for
                            employment.</li><br />
                        <li>Dishonesty or any dishonest action. Examples of "dishonesty" and dishonest
                            actions" are theft, pilfering and making false statement to secure an excused
                            absence.</li><br />
                        <li>Performing work for another employer or other person (s) during scheduled
                            working hours.</li><br />
                        <li>Fighting or any other form of physical violence, while in the context of
                            Family Matter employment. </li><br />
                        <li> Committing immoral or indecent acts while functioning as a company employee.</li><br />
                        <li>Purposely damaging or destroying company property, tools, equipment, motor
                            vehicles or the property of company employees/contractors or others.</li><br />
                        <li>Sexual harassment of employees/contractors, visitors or members of the
                            general public sexual harassment.
                        </li><br />
                        <li>Unexcused absence of three consecutive workdays or failure, to return from a
                            leave of absence.</li></ol></p>

                <p className='w-750'><span className='eleHeader'>PROGRESSIVE DISCIPLINE</span>
                    The purpose of this policy is to state the company's position on administering
                    equitable and consistent discipline for unsatisfactory conduct in the workplace. The
                    best disciplinary measure is the one that does not have to be enforced and comes
                    from good leadership and fair supervision at all employment levels. <br /><br />

                    The company's own best interest lies in ensuring fair treatment of all
                    employees/contractors and in making certain that disciplinary actions are prompt,
                    uniform, and impartial. The major purpose of any disciplinary action is to correct the
                    problem, prevent recurrence and prepare the employee for satisfactory service in the
                    future. <br /> <br />
                    Although employment with APEX is based on mutual consent and both the employee
                    and the company have the right to terminate employment at will with or without cause
                    or advance notice. Family Matter may use progressive discipline at its discretions.
                    <br /><br />
                    Disciplinary action may call for any of three steps - verbal warning written warning, or
                    termination of employment - depending on the severity of the problem and the number
                    of occurrences. There may be circumstances when one or more steps are bypassed. <br /><br />

                    Progressive discipline means that, with respect to most disciplinary problems. These
                    steps will normally be followed: a first offense may call for a verbal warning, a next
                    offense may be followed by a written warning; and another offense may then lead to
                    termination of employment If more than 12 months (for minor infractions) or 24 months
                    (for major infractions) has passed since the last disciplinary action, the process will
                    normally start over. <br /> <br />

                    APEX recognizes that there are certain types of employee problems that are
                    serious enough to justify, in extreme situations, termination of employment, without
                    going through the usual progressive discipline steps. <br /><br />

                    While it is impossible to list every type of behavior that may be deemed a serious
                    offense, the Employee Conduct and Work Rules policy includes examples of problems
                    that may result in immediate suspension or termination of employment. However, the
                    problems listed are not all necessarily serious offenses, but may be examples of
                    unsatisfactory conduct that will trigger progressive discipline. By using progressive
                    discipline, we hope that most employee problems can be corrected at an early stage,
                    benefiting both the employee and the company. </p>

                <p className='w-750'><span className='DRUG-FREE WORKPLACE POLICY '>
                    APEX has a vital interest in the safety and proper supervision and well being of
                    all residents while maintaining efficiency and productivity in all its operations. In
                    fulfillment of its responsibilities, we are committed to the maintenance of a drug
                    and alcohol-free workplace. The following are the requirements of APEX to
                    maintain a drug-free workplace. </span>
                    <ol><li>All employees/contractors must be free from the effects of drugs and alcohol during scheduled working hours as a condition of employment. Drinking alcoholic beverages
                        or using drugs on duty, in company vehicles, during breaks or at lunch, or working or
                        reporting for work when impaired by or under the influence of alcohol, or when drugs
                        and/or drug metabolites are present in the employee's system, is strictly prohibited and
                        grounds for disciplinary action up to and including immediate discharge. <br />

                        In addition, employees/contractors are subject to disciplinary action up to and
                        including immediate discharge for the unlawful distribution, dispensation,
                        possession, concealment or sale of alcohol or drugs while on duty.
                    </li>
                        <li>Any employee who tests positive for drugs and/or has an alcohol concentration at or
                            above the prescribed limits will be subject to disciplinary action as outlined below.
                            Such employees/contractors will also be subject to the established procedures
                            regarding evaluation and treatment and return to duty and follow-up testing. </li>
                        <li> APEX also reserves the right to require return to duty and follow-up testing as a
                            result of a condition of reinstatement or continued employment in conjunction with or
                            following completion of an approved drug and/or alcohol treatment, counseling or
                            rehabilitation program. </li><ol type='A'>
                            <li>Drug-Free Awareness Program/Education and Training</li>APEX will inform its employees/contractors about:
                            <ol>
                                <li>the dangers of drug and alcohol
                                    abuse in the workplace;</li>
                                <li>the policy of maintaining a drug and alcohol-free workplace;</li>
                                <li>the availability of drug and alcohol treatment, counseling and rehabilitation
                                    programs; and</li>
                                <li>the penalties that may be imposed upon employees/contractors for
                                    drug and alcohol abuse violations.</li></ol>
                            <li>When Drug and Alcohol Testing May Be Required
                            </li>Employees/contractors shall be required to submit to urine testing for use of prohibited
                            drugs and/or Breathalyzer alcohol testing in the following circumstances:
                            <ol><li>Prior to employment a urine test will be required. </li>
                                <li>When there is reasonable suspicion which shall be based on specific observation
                                    concerning the appearance, behavior, speech and/or body odors of the employee. </li>
                                <li>When an employee is involved in an accident or on-the-job injury.
                                </li>
                                <li>As part of a random testing program for employees/contractors. </li>
                                <li>As part of a return to duty testing after the employee must have a verified negative
                                    drug and/or alcohol.</li></ol>
                        </ol></ol></p>

                <p className='w-750'><h4><b>DISCIPLINARY ACTION</b></h4>
                    Employees/contractors will be subject to disciplinary action, up to and including
                    discharge or contract termination for any of the following infractions:
                    <ol><li>Refusal to submit to and authorized drug or alcohol test. </li> <br />
                        <li> Drinking alcoholic beverages or using drugs while on duty and/or on
                            lunches.</li><br />
                        <li>Have an alcohol concentration of .04 or greater in any authorized test.</li></ol></p>

                <p className='w-750'><span className='eleHeader'>First offense
                </span>Suspension of not more than five (5) days</p>

                <p className='w-750'><span className='eleHeader'>Second offense</span>
                    Suspension of not more than thirty (30) days
                </p>

                <p className='w-750'><span className='eleHeader'>Third offense
                </span>Rehabilitation and Additional Testing <br />
                    In cases where an employee receives disciplinary action other than discharge for a drug
                    and/or alcohol related infraction, the following procedures shall also apply:
                    <ol>
                        <li>APEX may require the employee to participate in an approved treatment, counseling
                            or rehabilitation program for drug and/or alcohol abuse at the time discipline is
                            imposed.</li><br />
                        <li> If the employee is required to enroll in such a program, his/her reinstatement or
                            continued employment shall be contingent upon successful completion of the program
                            and remaining drug and alcohol free.</li><br />
                        <li>The employee must submit to any drug and/or alcohol testing administered part as
                            of the program and provide APEX with the results of said tests. The employee must
                            also provide Elite Lighting Services, Inc. with progress reports from his/her approved
                            treatment, counseling or rehabilitation program at least once per month.</li></ol></p>

                <p className='w-750'><span className='eleHeader'>CUSTOMER AND PUBLIC RELATIONS</span>
                    Our company's reputation has been built on excellent service and quality work. To
                    maintain the reputation requires the active participation of every employee.
                    <br /><br />
                    The opinions and attitudes that the customers have toward our company may be
                    determined for a long period of time by the actions of one employee. It is sometimes
                    easy to take an outside client for granted. Each employee must be sensitive to the
                    importance of providing courteous treatment in air working relationships.</p>

                <p className='w-750'><span className='eleHeader'>CONDUCT AT JOB SITE </span>
                    The opinions and attitudes that customers have toward our company may be
                    determined for a long period of time by the actions of one employee. It is sometimes
                    easy to take a customer for granted, but if we do, we run the risk of losing not only that
                    customer but his or her associates, friends or family who may also be customers or
                    prospective customers. <br /><br />
                    The nature of our business requires that employees/contractors perform most of the
                    work connected with a customer's assignment at the customer's site. The importance
                    of professional conduct when working at a customer's site cannot be emphasized enough. Professional conduct is a broad term that is open to may interpretations. The
                    following are guidelines for appropriate conduct when at a customer's site.
                    <ul><li>Discussions with non-employees/contractors of APEX should be limited to
                        matters that concern their department and level of responsibility.</li>
                        <li>Internal affairs may not be discussed with residents.</li>
                        <li>Refrain from discussing shortcomings or idiosyncrasies of employees/contractors
                            to residents.</li>
                        <li>Avoid conversation involving resident matters in all public places.</li></ul></p>

                <p className='w-750'><span className='eleHeader'>PROTECTING COMPANY INFORMATION </span>
                    Protecting our company's information is the responsibility of every employee and we
                    share a common interest in making sure it is not improperly or accidentally disclosed.
                    Do not discuss the company's confidential business with anyone who does not work for
                    the company. <br /><br />
                    All telephone calls regarding a current or former employee's position/compensation with
                    our company must be forwarded to the manager of human resources. <br /><br />
                    The company's address shall not be used for the receipt of personal mail.
                </p>

                <p className='w-750'><span className='eleHeader'>DRESS POLICY
                </span>Employees/contractors are expected to maintain the highest standards cleanliness and
                    present a neat, professional appearance always. <br /><br />
                    Our customer's satisfaction represents the most important and challenging aspect of our
                    business. Whether or not your job responsibilities place you in direct customer contact,
                    you represent the company with your appearance as well as your actions. The properly
                    attired individual helps to create a favorable image for the company, to the public and
                    fellow employees/contractors. <br /><br />
                    As part of the company dress policy, these are the sole responsibility of the employee:
                    <ul><li>Denim dresses, jumpers, skirts, pants, slacks, suits, blouses, cardigans,
                        sweaters, blazers </li>
                        <li>Blouses, tops, and shirts must be of enough length to cover the belt line </li>
                        <li>No leggings, stirrup pants, tight jeans, tight pants, or sweat pants </li>
                        <li>No tennis, athletic, or flip flop sandals (certain exceptions might apply)
                        </li>
                        <li>No t-shirts or athletic war (unless going on an outing that require that type of
                            dress)
                        </li>
                        <li>No short skirts, short shorts, or cut-off pants </li>
                        <li>Low heeled shoes, flats, loafers, any comfortable heels or shoes</li>
                        <li>No head scarves or head wraps (see exceptions) </li>
                        <li>No short skirts, short shorts, or too short blouses exposing skin </li></ul></p>

                <p className='w-750'><span className='eleHeader'>UNIFORMS </span>
                    Apex encourages on-site employees to wear Uniforms as a safety mechanism while on
                    property. As a small quaint facility, Apex has found that is very difficult to distinctly
                    distinguish patients from staff when moving freely about the office space. Due to the
                    varying nature and acuity levels of our patient's mental health, uniforms allow all staff to
                    quickly distinguish patients from staff even at across the room. While they are not
                    mandatory for contractors, they are recommended for safety reasons. Apex
                    encourages healthcare scrubs as the best professional office attire which allow us to
                    ensure safety while portraying a professional image for the company. Employees who
                    have completed the thirty (30) day probationary period are required to wear company
                    uniform during work hours and this is not optional. Employees/contractors who wear
                    uniforms are required to maintain the cleaning of said uniforms. <br /><br />

                    Each employee is expected to conduct themselves in a professional manner while in
                    company uniform, whether on or off the clock.</p>

                <p className='w-750'><span className='eleHeader'>ID CARDS (Currently N/A) </span>
                    All Staff members must always carry their APEX ID and must present it for inspection by
                    a company official or employee. Pay checks cannot be given or company vehicles
                    cannot be driven without the ID being present. <br /><br />

                    If your company ID is lost, a $10 replacement fee will be charged. </p>

                <table>
                    <tr>
                        <td className='w-750'><h4>ACKNOWELDGEMENT OF RECEIPT OF EMPLOYEE HANDBOOK AND NEW HIRE
                            ORIENTATION
                        </h4></td>
                    </tr>
                    <table>
                        <tr>
                            <td className='signature w-500'>&nbsp;</td>
                            <td className='signature w-250'>&nbsp;</td>
                        </tr>
                        <tr>
                            <td className='small w-500'>Signature of Individual or Legally Authorized Person</td>
                            <td className='small w-250'>Date</td>
                        </tr>
                    </table>

                </table>






            </div>
        </form>

    )
}   